import { sessionRepository } from "@/infrastructure/repositories/session/Session.repository";
import {
  ensureStudioSession,
  getLastSuccessfulBootstrapMs,
  type BootstrapSessionResult,
} from "@/infrastructure/services/auth/bootstrapSession";

const FRESH_SESSION_MS = 15_000;

type BootstrapSessionFailure = Extract<BootstrapSessionResult, { ok: false }>;

export type RecoverStudioSessionResult =
  | { status: "recovered" }
  | { status: "already_fresh" }
  | { status: "failed"; result: BootstrapSessionFailure };

export async function recoverStudioSession(): Promise<RecoverStudioSessionResult> {
  const bootstrappedRecently =
    Date.now() - getLastSuccessfulBootstrapMs() < FRESH_SESSION_MS;

  if (sessionRepository.hasReusableSession() && bootstrappedRecently) {
    return { status: "already_fresh" };
  }

  const result = await ensureStudioSession({ force: true });
  if (result.ok) {
    return { status: "recovered" };
  }

  return { status: "failed", result };
}
